<template>
	<ViewWrapper :carregando="carregando" :permissao="PERMISSOES_FGTAS.GERENCIAR_ACESSOS">
		<template #titulo>
			Configurar Acesso do Usuário
		</template>
		<template #botaoHeader>
			<v-row justify="center">
				<v-col cols="12" class="align-content-center">
					<v-btn
						block
						color="primary"
						text="SALVAR"
						:loading="carregando"
						:disabled="!alterou"
						@click="salvarConfiguracoes()"
					></v-btn>
				</v-col>
			</v-row>
		</template>
		<v-container v-if="dadosUsuario" fluid>
			<v-card flat rounded class="pa-4">
				<v-row>
					<v-col cols="12">
						<b :class="`text-${corTexto}`">Nome:</b> <span>{{ dadosUsuario.nome }}</span>
					</v-col>
					<v-col cols="12">
						<b :class="`text-${corTexto}`">CPF:</b> <span>{{ formatarCpf(dadosUsuario.cpf) }}</span>
					</v-col>
					<v-col cols="12">
						<b :class="`text-${corTexto}`">E-mail:</b> <span>{{ dadosUsuario.email }}</span>
					</v-col>
				</v-row>
			</v-card>
		</v-container>
		<v-container fluid v-if="salvou">
			<v-card flat rounded class="pa-4" :class="`border-md border-opacity-100 border-${corTexto}`">
				<v-row>
					<v-col cols="12" :class="`text-${corTexto} d-flex flex-row justify-center secondaryDark--text`">
						<b>Suas alterações foram salvas. Pode ser necessário que o usuário recarregue a página para que algumas alterações tenham efeito.</b>
					</v-col>
				</v-row>
			</v-card>
		</v-container>
		<v-container v-if="dadosUsuario && dadosUsuario.permissoes.includes(PERMISSOES_FGTAS.ACESSO_TOTAL)" fluid>
			<v-card flat rounded class="pa-4">
				<v-row>
					<v-col cols="12">
						<b :class="`text-${corTexto}`">
							Esse usuário possui Acesso Total e portanto não pode ter nenhuma de suas permissões alteradas!
							<br>
							Contate um desenvolvedor do sistema se acredita que esse acesso é indevido!
						</b>
					</v-col>
				</v-row>
			</v-card>
		</v-container>
		<v-container v-if="permissoes.length && dadosUsuario" fluid>
			<v-row>
				<v-col
					v-for="detalhe, index in detalhesPermissoes"
					:key="detalhe.permissao"
					cols="12"
					>
					<v-card class="pa-4">
						<div class="d-flex align-center">
							<v-switch
								v-model="permissoes[index]"
								class="text-uppercase"
								:label="detalhe.label"
								:loading="carregando"
								:color="corTexto"
								:disabled="dadosUsuario.permissoes.includes(PERMISSOES_FGTAS.ACESSO_TOTAL)"
								@click="setarAlterou"
								/>
						</div>
						<div v-if="detalhe.descricao" class="pb-4">
							{{ detalhe.descricao }}
						</div>
					</v-card>
				</v-col>
				<v-col v-if="dadosUsuario" cols="12">
					<v-card class="pa-4">
						<div class="d-flex align-center pt-2">
							<b :class="`text-${corTexto} pb-4`">SETOR DO USUÁRIO</b>
						</div>
						<div class="pb-4">
							Altere o setor do usuário.
							<v-combobox
								v-model="setorUsuario"
								:items="listaSetor"
								item-title="nome"
								item-value="id"
								:loading="carregando"
								@update:model-value="setarAlterou"
								/>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12">
					<v-card class="pa-4">
						<div class="d-flex align-center pt-2">
							<b :class="`text-${corTexto} pb-4`">GERENCIAR AGÊNCIAS</b>
						</div>
						<div class="pb-4">
							Garante o acesso à configuração de vínculo do usuário às agências da FGTAS.
							<v-row class="mt-4">
								<v-col cols="12" md="8">
									<div class="mb-2 mr-6 text-hidden">Agência</div>
									<v-text-field v-model="filtros.nome" />
								</v-col>
								<v-col cols="6" md="2" class="align-self-end mb-2">
									<v-btn
										block
										:color="corTexto"
										variant="outlined"
										text="LIMPAR"
										@click="limparFiltros"
									></v-btn>
								</v-col>
								<v-col cols="6" md="2" class="align-self-end mb-2">
									<v-btn
										block
										color="primary"
										text="PESQUISAR"
										@click="consultarAgencias()"
									></v-btn>
								</v-col>
								<v-col cols="12">
									<div v-if="agenciasVincualdas" class="mb-2 mr-6">Agências já vinculadas ao usuário:</div>
									<v-textarea v-if="agenciasVincualdas" v-model="agenciasVincualdas" readonly auto-grow bg-color="backgroundCard" no-resize rows="1" />
									<v-data-table
										:loading="carregando"
										:headers="headers"
										:items="listaAgencias"
										no-data-text="Nenhum dado encontrado!"
										loading-text="Carregando..."
										hide-default-footer
										class="mt-4"
										>
										<template v-slot:item.ativa="{ item }">
											<v-switch v-model="item.ativa" :color="corTexto" @change="handleAgencia(item)" :disabled="dadosUsuario.permissoes.includes(PERMISSOES_FGTAS.ACESSO_TOTAL)" />
										</template>
									</v-data-table>
									<v-container class="mt-0 pa-0">
										<v-row class="pa-0">
											<v-col class="ml-2 d-flex align-center">
												<span class="mr-5 mt-3 fs-15">{{ textoPaginacao }}</span>
											</v-col>
											<v-col class="d-flex justify-end">
												<v-pagination
													:disabled="carregando"
													total-visible=7
													:model-value="pagination.currentPage"
													@update:model-value="(event) => pagination.currentPage = event"
													:length="pagination.totalPages"
													/>
											</v-col>
										</v-row>
									</v-container>
								</v-col>
							</v-row>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row justify="end">
				<v-col cols="12" md="2" class="align-content-center">
					<v-btn
						block
						color="primary"
						text="SALVAR"
						:loading="carregando"
						:disabled="!alterou"
						@click="salvarConfiguracoes()"
					></v-btn>
				</v-col>
			</v-row>
		</v-container>
	</ViewWrapper>
</template>

<script setup>
import ViewWrapper from "@/components/commons/wrapper/ViewWrapper.vue";
import { PERMISSOES_FGTAS } from "@/utils/PermissaoUtils.js";
import { ErroAlert, SucessoAlert } from "@/utils/AlertUtils.js";
import { onMounted, ref, computed, watch } from "vue";
import { vuetify } from '@/plugins/vuetify'
import { buscarDadosUsuarioPorId } from "@/services/UsuarioService";
import { useRoute } from "vuetify/lib/composables/router";
import { formatarCpf } from "@/utils/CpfUtils.js";
import { buscarAgenciasPaginado } from "@/services/AgenciaService";
import { editarUsuario } from "@/services/UsuarioService";
import { buscarPermissoes } from "@/services/PermissaoService";
import { useStore } from "vuex";
import { listarSetores } from "@/services/ConsultaEntidadeService";

const route = useRoute();
const store = useStore();

const permissaoAcessoPagina = ref(PERMISSOES_FGTAS.GERENCIAR_ACESSOS);
const carregando = ref(true);
const salvou = ref(false);
const alterou = ref(false);
const listaAgencias = ref([]);
const dadosUsuario = ref();
const setorUsuario = ref();
const permissoes = ref([]);
const agenciasSelecionadas = ref([]);
const filtros = ref({
	nome: undefined,
});
const pagination = ref({
	page: 0,
	size: 10,
	perPage: 10,
	currentPage: 1,
	totalRows: 0,
	totalPages: 0,
});

const headers = [
	{ key: "nome", title: "AGÊNCIA", sortable: false },
	{ key: "ativa", title: "ATIVA", sortable: false },
];

const listaSetor = ref([]);

const detalhesPermissoes = ref([
	{ label: "ACESSO TOTAL", permissao: PERMISSOES_FGTAS.ACESSO_TOTAL },
	{ label: "VISUALIZAR PAINEL DO ADMINISTRADOR", permissao: PERMISSOES_FGTAS.VISUALIZAR_PAINEL_ADMIN },
	{ label: "GERENCIAR ACESSOS", permissao: PERMISSOES_FGTAS.GERENCIAR_ACESSOS },
	{ label: "CADASTRAR VAGA", permissao: PERMISSOES_FGTAS.CADASTRAR_VAGA },
	{ label: "ACOMPANHAR VAGA", permissao: PERMISSOES_FGTAS.ACOMPANHAR_VAGA },
	{ label: "CANCELAR VAGA", permissao: PERMISSOES_FGTAS.CANCELAR_VAGA },
	{ label: "ANALISAR VAGA", permissao: PERMISSOES_FGTAS.ANALISAR_VAGA },
	{ label: "VISUALIZAR SOLICITÇÃO DA VAGA", permissao: PERMISSOES_FGTAS.VISUALIZAR_SOLICITACAO_VAGA },
	{ label: "CADASTRAR ATENDIMENTO", permissao: PERMISSOES_FGTAS.CADASTRAR_ATENDIMENTO },
	{ label: "VISUALIZAR ATENDIMENTO", permissao: PERMISSOES_FGTAS.VISUALIZAR_ATENDIMENTO },
]);

const agenciasVincualdas = computed(() => {
	if (dadosUsuario.value && dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.ACESSO_TOTAL)) {
		return "O usuário possui acesso a todas as agências cadastradas no sistema."
	}
	if (!agenciasSelecionadas.value.length) {
		return "";
	}
	return agenciasSelecionadas.value.sort((a, b) => a.nome.localeCompare(b.nome)).map((x) => x.nome).join(", ");
});

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
});

const textoPaginacao = computed(() => {
	if(pagination.value.totalRows){
		if(pagination.value.totalRows === 0){
			return "Nenhum registro localizado";
		}
		if(pagination.value.totalRows === 1){
			return "1 registro recuperado";
		}
		return `${pagination.value.totalRows} registros recuperados`;
	}
	return "";
});

async function limparFiltros() {
	filtros.value.nome = undefined;
	await consultarAgencias();
}

async function consultarAgencias(page) {
	pagination.value.currentPage = page ? pagination.value.currentPage : 1;
	pagination.value.page = page ? pagination.value.currentPage - 1 : 0;
	carregando.value = true;
	await buscarAgenciasPaginado({
		page: pagination.value.page,
		size: pagination.value.size,
		perPage: pagination.value.perPage,
		currentPage: pagination.value.currentPage,
	}, {
		nome: filtros.value.nome ? filtros.value.nome : undefined,
		registroAtivo: true,
	})
		.then(({ data }) => {
			pagination.value.size = data.size;
			pagination.value.totalPages = data.totalPages;
			listaAgencias.value = data.content.map((agencia) => {
				return {
					...agencia,
					ativa: !!agenciasSelecionadas.value.find((a) => a.id === agencia.id),
				}
			});
			pagination.value.totalRows = data.totalElements;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível listar as agências no momento. Tente novamente mais tarde!", error });
		})
		.finally(() => carregando.value = false);
}

async function consultarPermissoes() {
	carregando.value = true;
	await buscarPermissoes()
		.then(({ data }) => {
			detalhesPermissoes.value = detalhesPermissoes.value.map((permissao) => {
				return {
					label: data.find((d) => d.codigo === permissao.permissao).nome || permissao.label,
					descricao:  data.find((d) => d.codigo === permissao.permissao).descricao || "",
					permissao: permissao.permissao,
				}
			})
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível listar as permissões no momento. Tente novamente mais tarde!", error });
		})
		.finally(() => carregando.value = false);
}

async function carregarUsuario() {
	carregando.value = true;
	await buscarDadosUsuarioPorId(route.value.params?.id || 0)
		.then(({data}) => {
			dadosUsuario.value = {
				permissoes: [],
				...data,
			};
			setorUsuario.value = dadosUsuario.value.setor;
			permissoes.value = [
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.ACESSO_TOTAL),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.VISUALIZAR_PAINEL_ADMIN),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.GERENCIAR_ACESSOS),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.CADASTRAR_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.ACOMPANHAR_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.CANCELAR_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.ANALISAR_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.VISUALIZAR_SOLICITACAO_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.CADASTRAR_ATENDIMENTO),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.VISUALIZAR_ATENDIMENTO),
			];
			if (data.agencias && data.agencias.length) {
				agenciasSelecionadas.value = data.agencias.map((agencia) => {
					return {
						...agencia.agencia,
						idAgencia: agencia.id,
					}
				});
			}
		})
		.catch((erro) => {
			ErroAlert({ mensagem: "Erro ao buscar dados do usuário! Tente novamente mais tarde.", erro });
		})
		.finally(() => {
			carregando.value = false;
		});
};

function handleAgencia(agencia) {
	alterou.value = true;
	if (agenciasSelecionadas.value.find((a) => a.id === agencia.id)) {
		agenciasSelecionadas.value = agenciasSelecionadas.value.filter((a) => a.id !== agencia.id);
		return;
	}
	agenciasSelecionadas.value.push(agencia);
}

async function buscaSetores() {
	if (store.getters["entidades/getListaSetores"].length) {
		listaSetor.value = store.getters["entidades/getListaSetores"];
		return;
	}
	await listarSetores()
		.then(({ data }) => {
			listaSetor.value = data;
			store.commit("entidades/setListaSetores", data);
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}


async function salvarConfiguracoes() {
	const bodyRequest = {
		id: dadosUsuario.value.id,
		email: dadosUsuario.value.email,
		cpf: dadosUsuario.value.cpf,
		nome: dadosUsuario.value.nome,
		permissoes: permissoes.value.map((value, index) => {
			if (value) {
				return detalhesPermissoes.value[index].permissao;
			}
		}).filter((val) => val),
		setor: setorUsuario.value,
		agencias: agenciasSelecionadas.value.map((agencia) => {
			return {
				agencia: agencia,
				id: agencia.idAgencia,
			}
		}),
	}
	carregando.value = true;
	await editarUsuario(route.value.params?.id || 0, bodyRequest)
		.then(async ({ data }) => {
			SucessoAlert({ mensagem: "Suas alterações foram salvas. Pode ser necessário que o usuário recarregue a página para que algumas alterações tenham efeito." });
			salvou.value = true;
			dadosUsuario.value = {
				permissoes: [],
				...data,
			};
			setorUsuario.value = dadosUsuario.value.setor;
			permissoes.value = [
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.ACESSO_TOTAL),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.VISUALIZAR_PAINEL_ADMIN),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.GERENCIAR_ACESSOS),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.CADASTRAR_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.ACOMPANHAR_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.CANCELAR_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.ANALISAR_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.VISUALIZAR_SOLICITACAO_VAGA),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.CADASTRAR_ATENDIMENTO),
				dadosUsuario.value.permissoes.includes(PERMISSOES_FGTAS.VISUALIZAR_ATENDIMENTO),
			];
			if (data.agencias && data.agencias.length) {
				agenciasSelecionadas.value = data.agencias.map((agencia) => {
					return {
						...agencia.agencia,
						idAgencia: agencia.id,
					}
				});
			}
			await consultarAgencias();
		})
		.catch((erro) => {
			ErroAlert({ mensagem: "Erro ao salvar usuário! Tente novamente mais tarde.", erro });
		})
		.finally(() => {
			carregando.value = false;
		});
}

function setarAlterou(){
	alterou.value = true;
}

watch(() => pagination.value.currentPage, async (newValue, oldValue) => {
	if (newValue !== oldValue) {
		await consultarAgencias(newValue);
	}
}, { deep: true });

onMounted(async () => {
	await buscaSetores();
	await consultarPermissoes();
	await carregarUsuario();
	await consultarAgencias();
});
</script>
